import {
  Avatar,
  Box,
  Button,
  ButtonBase,
  Grid,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { ROUTES } from "constants/routes";
import { useNavigate } from "react-router-dom";
import { Fragment } from "react/jsx-runtime";

const Section3Items = [
  {
    icon: require("assets/img/png/tractor_green_ic.png"),
    title: `Lisitng`,
    subtitle: `Tractor owners create a listing on the Haystackers, providing relevant details about their tractor and equipment, including the make, model, size, specifications, availability, and pricing. You may also upload photos and additional information to attract potential renters.`,
  },
  {
    icon: require("assets/img/png/calendar_ic.png"),
    title: `Search and Booking`,
    subtitle: `Renters can search for tractors and equipment that suit their specific needs using filters such as location, tractor / equipment type, rental duration, and desired specifications. Once Renters find a suitable tractor or equipment, Renters can review the listing details, communicate with the owner to clarify any questions or concerns, and proceed with the booking process.`,
  },
  {
    icon: require("assets/img/png/communication_ic.png"),
    title: `Communication`,
    subtitle: `Renters and owners can communicate directly through the Haystackers’ messaging system or other contact methods provided and discuss rental terms, availability, pickup/drop-off arrangements, any necessary documentation, and any additional services or conditions associated with the rental.`,
  },
  {
    icon: require("assets/img/png/money_ic 2.png"),
    title: `Reservation and Payment`,
    subtitle: `When the renter is ready to proceed, the renter can confirm the reservation and make the payment through Haystackers. Haystackers usually handles the financial transaction, facilitating a secure payment process and often charging a fee or commission for their services.`,
  },
  {
    icon: require("assets/img/png/return_ic.png"),
    title: `Pickup and Return`,
    subtitle: `On the agreed-upon dates, the renter meets the owner to pick up the tractor. The owner may provide instructions on operating the tractor, maintenance requirements, and any safety considerations. At the end of the rental period, the renter returns the tractor to the owner in the agreed condition.`,
  },
];

const Benefits = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const navigate = useNavigate();

  return (
    <Fragment>
      <Box
        sx={{
          p: isMobile ? "24px" : "120px",
        }}
      >
        <Grid container spacing={3}>
          <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
            <Box
              component="img"
              sx={{
                width: "100%",
                height: {
                  md: "664px",
                  lg: "664px",
                  xl: "664px",
                  sm: "320px",
                  xs: "320px",
                },
                objectFit: "contain",
              }}
              src={"/assets/img/benefits.png"}
              alt=""
            />
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: "10px",
                justifyContent: "center",
              }}
            >
              <Typography
                sx={{
                  fontFamily: "Bayon",
                  fontWeight: 400,
                  fontSize: isMobile ? "15px" : "18px",
                  lineHeight: isMobile ? "27.1px" : "32.5px",
                  color: "#6E8C20",
                  textTransform: "uppercase",
                }}
              >
                Benefits
              </Typography>
              <Typography
                sx={{
                  fontFamily: "Inter",
                  fontWeight: 600,
                  fontSize: isMobile ? "26px" : "72px",
                  lineHeight: isMobile ? "36px" : "82px",
                }}
              >
                <span style={{ color: "#6E8C20" }}>Benefit </span>
                of Renting Farm Equipment
              </Typography>
            </Box>

            <Stack
              direction="column"
              // justifyContent="center"
              // alignItems="center"
              spacing={3}
              mt={6}
            >
              {[
                "Earn money on your idle equipment.",
                `Help farmers by their your equipment.`,
                `Connect with farmers directly and sharing farming expertise.`,
                `Money hits your bank account within 24-48 hrs.`,
                `Every rental is covered with liability insurance.`,
                `Set your rental prices and schedule.`,
              ]?.map((el) => (
                <Box
                  key={el}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: "20px",
                  }}
                >
                  <img
                    style={{
                      width: isMobile ? "24px" : "32px",
                      height: isMobile ? "24px" : "32px",
                      objectFit: "contain",
                    }}
                    src={require("assets/img/png/successful_check.png")}
                    alt=""
                  />

                  <Typography
                    sx={{
                      fontFamily: "Inter",
                      fontWeight: 500,
                      fontSize: isMobile ? "15px" : "17px",
                      lineHeight: isMobile ? "22px" : "31px",
                    }}
                  >
                    {el}
                  </Typography>
                </Box>
              ))}
              <ButtonBase
                sx={{
                  height: "56px",
                  width: "160px",
                  background: "#6E8C20",
                  borderRadius: "10px",
                  mt: "20px",
                }}
                onClick={() =>
                  navigate(
                    `${ROUTES.SIGNIN}?redirect=${ROUTES.EQUPIMENT_LISTING}`
                  )
                }
              >
                <Typography
                  sx={{
                    fontWeight: 500,
                    fontSize: "15px",
                    lineHeight: "18px",
                    color: "#FFF",
                  }}
                >
                  Get Started
                </Typography>
              </ButtonBase>
            </Stack>
          </Grid>
        </Grid>
      </Box>
      {/* End of 4th section   */}
    </Fragment>
  );
};

export default Benefits;
